import React, {createContext, useState} from "react";
import {appConfig} from "config/defaultConfig";
import {useLocation} from "react-router-dom";

const {ROUTES} = appConfig.APP;

/**
 * This context is intended to share state between all sections on the page.
 * i.e.:
 * - Graph
 * - Table
 * - List Views
 * - Drawer
 *
 * This Context will likely expand as we implement the other page sections.
 * All Graph specific state has been moved to 'RelationsGraphContext`.
 */
const InvestigationDetailContext = createContext({
  isSavedInvestigation: false,
  isFullscreen: false,
  setIsFullscreen: (state) => {}
});

const InvestigationDetailProvider = ({children}) => {
  const {pathname} = useLocation();

  const [isFullscreen, setIsFullscreen] = useState(false);

  /**
   * Check the route to determine if we arrived here from running a new investigation (false),
   * or if we arrived here by fetching a saved investigation's id.
   */
  const isSavedInvestigation =
    pathname.substring(pathname.lastIndexOf("/")) === ROUTES.SAVED;

  return (
    <InvestigationDetailContext.Provider
      value={{
        isSavedInvestigation,
        isFullscreen,
        setIsFullscreen
      }}>
      {children}
    </InvestigationDetailContext.Provider>
  );
};

export {InvestigationDetailContext, InvestigationDetailProvider};
